export default "__VITE_PUBLIC_ASSET__c435dd85__"